import { render, staticRenderFns } from "./create.vue?vue&type=template&id=2fda0548&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=2fda0548&prod&lang=css&"
import style1 from "./create.vue?vue&type=style&index=1&id=2fda0548&prod&lang=scss&scoped=true&"
import style2 from "./create.vue?vue&type=style&index=2&id=2fda0548&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda0548",
  null
  
)

export default component.exports